import { Flame } from "lucide-react";

const ITEMS = [
  "Dine-In Flagships",
  "Cloud Kitchen Network",
  "9 Hospital Canteens",
  "5 Delivery Brands",
  "Zomato Partnered",
  "Swiggy Partnered",
  "WhatsApp Direct Ordering",
  "Tier-2 Food Leaders",
  "Est. 2010",
];

const Row = ({ ariaHidden }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-lg font-semibold uppercase tracking-wide text-obsidian sm:text-xl">
          {item}
        </span>
        <Flame size={18} className="shrink-0 text-obsidian/60" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section data-testid="editorial-marquee" className="relative z-10 -my-5 overflow-hidden">
      <div className="w-[104%] -translate-x-[2%] -rotate-[1.2deg] border-y-4 border-obsidian bg-saffron py-4 shadow-[0_20px_60px_rgba(245,158,11,0.25)]">
        <div className="flex w-max animate-marquee">
          <Row ariaHidden={false} />
          <Row ariaHidden={true} />
        </div>
      </div>
    </section>
  );
}
